import service from '@/utils/request'

export function userLogin(data) {
  return service({
    url: '/api/user/login',
    method: 'post',
    data
  })
}

export function userPasswordNoLogin(data) {
  return service({
    url: '/api/user/password_no_login',
    method: 'post',
    data
  })
}

export function pubNotice(data) {
  return service({
    url: '/api/pub/notice',
    method: 'post',
    data
  })
}

export function userLogout(data) {
  return service({
    url: '/api/user/logout',
    method: 'post',
    data
  })
}

export function userInfo(data) {
  return service({
    url: '/api/user/info',
    method: 'post',
    data
  })
}

export function userList(data) {
  return service({
    url: '/api/user/list',
    method: 'post',
    data
  })
}

export function userAdd(data) {
  return service({
    url: '/api/user/add',
    method: 'post',
    data
  })
}

export function userEdit(data) {
  return service({
    url: '/api/user/edit',
    method: 'post',
    data
  })
}

export function userPassword(data) {
  return service({
    url: '/api/user/password',
    method: 'post',
    data
  })
}

export function userFindPassword(data) {
  return service({
    url: '/api/pub/find/password',
    method: 'post',
    data
  })
}

export function userDelete(data) {
  return service({
    url: '/api/user/delete',
    method: 'post',
    data
  })
}

export function userSuggest(data) {
  return service({
    url: '/api/user/suggest',
    method: 'post',
    data
  })
}